import { Tag } from "antd";
import React, { ReactNode } from "react";
import CompressorOffReason from "src/consts/CompressorOffReason";
import HeaterMode from "src/consts/HeaterMode";
import BinDTO from "src/models/BinDTO";
import "../app/statusIcons.css";

export const formatHeaterMode = (heaterMode: HeaterMode) => {
    if (heaterMode == null) {
        return "--";
    }
    if (heaterMode === HeaterMode.Ambient) {
        return "Ambient";
    }
    else if (heaterMode === HeaterMode.EnergyEff) {
        return "Efficiency";
    }
    else if (heaterMode === HeaterMode.Speed5) {
        return "5 Deg";
    }
    else if (heaterMode === HeaterMode.Speed10) {
        return "10 Deg";
    }
    else {
        return "Unknown";
    }
}

export const OnStatus = (props: any) => {
    return <Tag className="status-tag-on" color="green" {...props}>On</Tag>
}

export const OffStatus = (props: any) => {
    return <Tag className="status-tag-off" color="red" {...props}>Off</Tag>
}
export const PausedStatus = (props: any) => {
    return <Tag className="status-tag-paused" color="orange" {...props}>Paused</Tag>
}

/**
 * Format the compressor status for display in React components (do not use in chart.js or three.js)
 */
export const formatCompressorStatusReact = (binDTO: BinDTO | null | undefined): string | ReactNode | null => {
    if (binDTO?.compressorState == null) {
        return null;
    }
    const compressorState = binDTO.compressorState;
    if (compressorState.offReason == null) {
        return <OnStatus />;
    }
    else if (compressorState.offReason === CompressorOffReason.UserRequested) {
        return <OffStatus />;
    }
    else if (compressorState.offReason === CompressorOffReason.OverrideRequested) {
        return <Tag className="status-tag-off" color="red">Off Override</Tag>;
    }
    else {
        return <PausedStatus />;
    }
}

// Closed or Active
export const areValvesPermanentlyClosed = (binDTO: BinDTO | null | undefined): boolean | null => {
    if (binDTO == null) {
        return null;
    }
    return binDTO.routineEngine?.anyStaticValvePositions === false &&
    (binDTO?.manualRoutineSettings?.isManualRoutineSet === false || binDTO?.routineEngine?.routine == null)
}

export const formatValvesStatus = (binDTO: BinDTO | null | undefined): string | null => {
    const areValvesClosed = areValvesPermanentlyClosed(binDTO);
    if (areValvesClosed == null) {
        return "No Data";
    }
    else if (areValvesClosed === false) {
        return "Active";
    }
    else {
        return "Closed";
    }
}


export const formatPlenumPressure = (plenumPressure: number | null | undefined): string => {
    if (!Number.isFinite(plenumPressure)) {
        return "";
    }
    if (plenumPressure == null) {
        return "";
    }

    return plenumPressure.toFixed(2);
}


export const formatNumber = (num: number | null | undefined, options: { decimalPlaces?: number | true, filler?: string, suffix?: string, showSuffixIfNoValue?: boolean }) => {
    const decimals = options?.decimalPlaces ?? 1;
    const filler = options.filler ?? "--";
    const suffix = options.suffix ?? "";
    const showSuffixIfNoValue = options.showSuffixIfNoValue ?? false;

    if (Number.isFinite(num)) {
        let safeNumber = num as number;
        let rounded: number | string = safeNumber;
        if (decimals === true) {
            rounded = safeNumber;
        }
        else {
            rounded = Number(safeNumber)?.toFixed(decimals);
        }
        return `${rounded}${suffix}`;
    } else {

        return `${filler}${showSuffixIfNoValue ? suffix : ''}`;
    }
}